import {invoke} from "@hybird/core/bridge/hybirdBridge";
import {BridgeMethod} from "@hybird/core/bridge/core";

export class FlutterXda extends BridgeMethod {
  constructor() {
    super();
  }

  async chooseMedia() {
    return invoke('chooseMedia');
  }

  async chooseFile(allowedExtensions) {
    return invoke('chooseFile', {params: {allowedExtensions}});
  }

  async openAppSettings(type) {
    return invoke('openAppSettings', {params: {type}});
  }

  async getAllLocalStorageKeys(isDefault) {
    return invoke('getAllLocalStorageKeys', {params: {isDefault}});
  }

  async clearLocalStorageKeys(isDefault) {
    return invoke('clearLocalStorageKeys', {params: {isDefault}});
  }

  async removeLocalStorage(key, isDefault) {
    return invoke('removeLocalStorage', {params: {key, isDefault}});
  }

  async getLocalStorage(key, isDefault) {
    return invoke('getLocalStorage', {params: {key, isDefault}});
  }

  async setLocalStorage(key, data, isDefault) {
    return invoke('setLocalStorage', {params: {key, data, isDefault}});
  }
}